<template>
  <div :class="[$style.watermark, $style[ribbonPosition]]">
    <a href="https://onvocado.com/?utm_source=link&utm_medium=onvocado_popup" target="_blank">
      <span :class="[$style.poweredBy]">Powered by onvocado</span> </a>
<!--    🔋-->
  </div>
</template>

<script>
export default {
  name: 'Watermark',
  props: {
    isRibbon: {
      type: Boolean,
      default: false,
    },
    ribbonPosition: {
      type: String,
      required: false,
      default: 'bottomRight',
    },
  },
}
</script>

<style lang="scss" module>
@import '@shared/assets/sass/design/_breakpoints';

.watermark.watermark {
  position: absolute;
  bottom: 20px;
  color: #f8f8f8;
  font-size: .85em;
  z-index: 20;

  a, a:visited, a:hover, a:active {
    color: inherit;
  }

  @media screen and (max-width: $bp-tablet) {
    bottom: 10px;
  }
}

.poweredBy {
  text-transform: uppercase;
}

.bottomRight {
  left: 20px;
  right: auto;

  @media screen and (max-width: $bp-tablet) {
    left: 10px;
  }
}

.bottomLeft {
  left: auto;
  right: 20px;

  @media screen and (max-width: $bp-tablet) {
    right: 10px;
  }
}
</style>